import styles from '../assets/css/button.module.css';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectPrimaryColor, selectSecondaryColor } from '../app/slices/configuration.slice';

interface NextButtonProps {
	text: string | JSX.Element;
	onClick(): void;
	disabled?: boolean;
}

const NextButton = ({ onClick, text, disabled = false }: NextButtonProps) => {
	const primaryColor = useSelector(selectPrimaryColor) as string;
	const secondaryColor = useSelector(selectSecondaryColor) as string;
	const buttonStyle = {
		backgroundImage: `linear-gradient(to right, ${primaryColor}, ${secondaryColor})`,
		backgroundPosition: '20% 0'
	};

	return (
		<button
			id="next-button"
			className={styles['next-button']}
			onClick={onClick}
			disabled={disabled}
			style={buttonStyle}
		>
			{text}
		</button>
	);
};

export default memo(NextButton);
